import { BsBoxSeam, BsThreeDotsVertical } from "react-icons/bs";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdError, MdOutlinePeopleAlt, MdWarning } from "react-icons/md";
import { PiWarningBold } from "react-icons/pi";
import { FaCheckCircle, FaDownload, FaExclamationCircle, FaListAlt } from "react-icons/fa";
import { LuQrCode } from "react-icons/lu";
import DASHBOARD_HEADINGS, { COMPLAINT_HEADINGS, PRODUCT_HEADINGS } from "../pages/home/dashboardConstants";


export const iconMap = {
    "DASHBOARD": {
        [DASHBOARD_HEADINGS.TOTAL_REGISTERED_DEVICE]: BsBoxSeam,
        [DASHBOARD_HEADINGS.OPEN_COMPLAINTS]: PiWarningBold,
        [DASHBOARD_HEADINGS.RESOLVED]: IoMdCheckmarkCircleOutline,
        [DASHBOARD_HEADINGS.CUSTOMERS]: MdOutlinePeopleAlt,
    },
    "COMPLAINT": {
        [COMPLAINT_HEADINGS.TOTAL]: FaListAlt,
        [COMPLAINT_HEADINGS.RESOLVED]: FaCheckCircle,
        [COMPLAINT_HEADINGS.OPEN]: FaExclamationCircle,
    },
    "PRODUCT": {
        [PRODUCT_HEADINGS.TOTAL]: BsBoxSeam,
        [PRODUCT_HEADINGS.ACTIVE_WARRANTIES]: IoMdCheckmarkCircleOutline,
        [PRODUCT_HEADINGS.EXPIRING]: MdWarning,
        [PRODUCT_HEADINGS.QR_REGISTRATIONS]: MdError,
    },
    "QR_GENERATION": {
        "QR Codes Generated": LuQrCode,
    },
    "EXPORT": FaDownload,
    "ACTION_DOTS": BsThreeDotsVertical
};

export const iconColorMap = {
    "DASHBOARD": {
        [DASHBOARD_HEADINGS.TOTAL_REGISTERED_DEVICE]: "blue",
        [DASHBOARD_HEADINGS.OPEN_COMPLAINTS]: "orange",
        [DASHBOARD_HEADINGS.RESOLVED]: "green",
        [DASHBOARD_HEADINGS.CUSTOMERS]: "purple",
    },
    "COMPLAINT": {
        [COMPLAINT_HEADINGS.TOTAL]: "blue",
        [COMPLAINT_HEADINGS.RESOLVED]: "green",
        [COMPLAINT_HEADINGS.OPEN]: "red",
    },
    "PRODUCT": {
        [PRODUCT_HEADINGS.TOTAL]: "blue",
        [PRODUCT_HEADINGS.ACTIVE_WARRANTIES]: "green",
        [PRODUCT_HEADINGS.EXPIRING]: "orange",
        [PRODUCT_HEADINGS.QR_REGISTRATIONS]: "red",
    },
    "QR_GENERATION": {
        "QR Codes Generated": "blue",
    },
};
